import { absolutePath } from "./absolutePath";

interface CurrentContactFnProps {
  params?: Record<string, unknown>;
}

export const currentContact = {
  show: ({ params = {} }: CurrentContactFnProps = {}) =>
    absolutePath("current_contact", params),
};
